var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23096 7.92326H13.3079C13.554 7.92326 13.7694 7.70788 13.7694 7.46173V6.53865C13.7694 6.2925 13.554 6.07711 13.3079 6.07711H8.23096C8.04634 6.07711 7.92326 5.95403 7.92326 5.76942V0.692496C7.92326 0.446342 7.70788 0.230957 7.46173 0.230957H6.53865C6.2925 0.230957 6.07711 0.446342 6.07711 0.692496V5.76942C6.07711 5.95403 5.95403 6.07711 5.76942 6.07711H0.692496C0.446342 6.07711 0.230957 6.2925 0.230957 6.53865V7.46173C0.230957 7.70788 0.446342 7.92326 0.692496 7.92326H5.76942C5.95403 7.92326 6.07711 8.04634 6.07711 8.23096V13.3079C6.07711 13.554 6.2925 13.7694 6.53865 13.7694H7.46173C7.70788 13.7694 7.92326 13.554 7.92326 13.3079V8.23096C7.92326 8.04634 8.04634 7.92326 8.23096 7.92326Z",
    fill: "#F9FBFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.6ab83a745f24c57aa0b6a20e8201924a.svg";
export { ForwardRef as ReactComponent };